/* Desktop prev/next arrows on the PDP main image (thumbnail gallery layouts),
   plus rail follow: the vertical thumbnail rail scrolls just enough to keep
   the active thumb in view — one spot at a time. Only the rail's scrollTop
   moves, so the section's height never changes. */
(function () {
  'use strict';

  if (window.__pdpGalleryArrowsBound) return;
  window.__pdpGalleryArrowsBound = true;

  function visibleThumbs(gallery) {
    return Array.prototype.filter.call(
      gallery.querySelectorAll('.thumbnail-list__item button'),
      function (thumb) {
        return thumb.offsetParent !== null;
      }
    );
  }

  function scrollRailToCurrent(gallery) {
    var list = gallery.querySelector('.thumbnail-list');
    if (!list) return;
    var current = list.querySelector('button[aria-current="true"]');
    if (!current) return;
    var item = current.closest('.thumbnail-list__item') || current;
    var listBox = list.getBoundingClientRect();
    var itemBox = item.getBoundingClientRect();
    if (itemBox.bottom > listBox.bottom) {
      list.scrollBy({ top: itemBox.bottom - listBox.bottom, behavior: 'smooth' });
    } else if (itemBox.top < listBox.top) {
      list.scrollBy({ top: itemBox.top - listBox.top, behavior: 'smooth' });
    }
  }

  function followSoon(gallery) {
    // Give media-gallery.js a beat to move aria-current first.
    setTimeout(function () {
      scrollRailToCurrent(gallery);
    }, 120);
  }

  document.addEventListener('click', function (event) {
    // Arrow stepping
    var button = event.target.closest('[data-media-step]');
    if (button) {
      var gallery = button.closest('media-gallery');
      if (!gallery) return;
      var thumbs = visibleThumbs(gallery);
      if (thumbs.length < 2) return;
      var current = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('aria-current') === 'true';
      });
      if (current === -1) current = 0;
      var step = parseInt(button.dataset.mediaStep, 10) || 1;
      var next = (current + step + thumbs.length) % thumbs.length;
      thumbs[next].click();
      followSoon(gallery);
      return;
    }

    // Direct thumb clicks: re-centre a half-visible thumb.
    var thumb = event.target.closest('.thumbnail-list__item button');
    if (thumb) {
      var thumbGallery = thumb.closest('media-gallery');
      if (thumbGallery) followSoon(thumbGallery);
    }
  });

  // Mobile swipe / programmatic slides: Dawn's slider fires slideChanged on
  // the viewer slider-component. Capture phase catches it from the document
  // even though it doesn't bubble.
  document.addEventListener(
    'slideChanged',
    function (event) {
      var gallery = event.target && event.target.closest && event.target.closest('media-gallery');
      if (gallery) followSoon(gallery);
    },
    true
  );

  // Mouse wheel over the thumbnail rail scrolls the thumbs (not the page).
  document.addEventListener(
    'wheel',
    function (event) {
      if (!event.target.closest) return;
      var list = event.target.closest('.product--thumbs-left .thumbnail-list');
      if (!list || list.scrollHeight <= list.clientHeight) return;
      event.preventDefault();
      list.scrollTop += event.deltaY;
    },
    { passive: false }
  );
})();
